<template>
  <div class="waybill-tag-content">
    <span class="waybill-tag-title">运单标签：</span>
    <template v-if="waybillTagList.length > 0">
      <span class="waybill-tag-item" v-for="item in displayTags" :key="item">{{ item }}</span>
      <span v-show="hasOverflow" class="waybill-tag-toggle" @click="toggleAll">
        {{ isAll ? '收起' : '展开' }}
      </span>
    </template>
    <span v-else>--</span>
  </div>
</template>
<script>
import { WaybillTagContentApi } from './pool'
// 运单号正则UAT
const WAYBILL_NO_REGEX_UAT = /^([JU]T)\d{13}$|^\d{13}$/;

export default {
  name: 'WaybillTagContent',
  props: {
    limit: {
      type: Number,
      default: 27
    },
    waybillNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isAll: false,
      waybillTagList: []
    }
  },
  watch: {
    waybillNo(newVal) {
      this.waybillTagList = []
      if (newVal && WAYBILL_NO_REGEX_UAT.test(newVal)) {
        this.getWaybillTag({
          waybillNo: newVal
        })
      }
    }
  },
  computed: {
    displayTags() {
      if (this.isAll) {
        return this.waybillTagList
      }
      const limitIndex = this.getOverflowIndex(this.limit)
      if (this.getOverflowIndex(this.limit) !== -1) {
        return this.waybillTagList.slice(0, limitIndex)
      }
      return this.waybillTagList
    },
    hasOverflow() {
      return this.getOverflowIndex(this.limit) !== -1
    }
  },
  mounted() {
    this.getWaybillTag({
      waybillNo: this.waybillNo
    })
  },
  methods: {
    async getWaybillTag(reqData) {
      if (!reqData.waybillNo) {
        return
      }
      const { code, msg, data } = await WaybillTagContentApi.reqWaybillTag(reqData)
      if (code === 1) {
        this.waybillTagList = data?.labelList || []
      } else {
        this.message.error(msg)
      }
    },
    getOverflowIndex(limit) {
      let count = 0
      for (let i = 0; i < this.waybillTagList.length; i++) {
        count += this.waybillTagList[i]?.length || 0
        if (count > limit) {
          return i
        }
      }
      return -1
    },
    toggleAll() {
      this.isAll = !this.isAll
    }
  }
}
</script>
<style scoped lang="scss">
.waybill-tag-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  vertical-align: middle;

  .waybill-tag-title {
    @include text-color('subtitle');
  }

  .waybill-tag-item {
    display: inline-block;
    border: 1px solid #E60012;
    padding: 0px 5px;
    border-radius: 15px;
    font-size: 12px;
    color: #E60012;
    white-space: nowrap;

    /* 默认截断样式 */
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .waybill-tag-toggle {
    color: #1890ff;
    cursor: pointer;
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 4px;
    transition: background-color 0.3s;

    &:hover {
      background-color: #f0f9ff;
    }
  }
}

/* 展开模式下的样式 */
.waybill-tag-content.waybill-tag-all {
  .waybill-tag-item {
    max-width: none;
    white-space: normal;
  }
}
</style>
